import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();

  console.log('ProtectedRoute check:', { isAuthenticated, path: location.pathname });

  if (!isAuthenticated) {
    console.log('Not authenticated, redirecting to login with state:', location);
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <>{children}</>;
};
